"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _CarouselHeader = require("../CarouselHeader/CarouselHeader");
var _CarouselHeadingArea = require("../CarouselHeadingArea/CarouselHeadingArea");
var _CarouselNavControls = require("../CarouselNavControls/CarouselNavControls");
var _CarouselScrollContainer = require("../CarouselScrollContainer/CarouselScrollContainer");
var _CarouselSkipLink = require("../CarouselSkipLink/CarouselSkipLink");
var _CarouselSlide = require("../CarouselSlide/CarouselSlide");
var _Carousel = require("./Carousel.styles");
var _excluded = ["aria-label", "children", "enableSnap", "heading", "includeSkipLink", "onNextClick", "onPreviousClick", "onScroll", "renderNavigationControls", "role", "scrollOffset", "slideAlign", "slideGap", "slideWidth", "hasFocusableContent"];
/**
 * @since 8.71.0
 */
var Carousel = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Carousel, _Component);
  function Carousel(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.updateNavControlStates = function () {
      if (_this.scrollWrapper.current) {
        _this.enablePreviousAction(_this.scrollWrapper.current.scrollLeft === 0);
        // Add 1px to account for potential rounding issues
        _this.enableNextAction(_this.scrollWrapper.current.scrollWidth <= _this.scrollWrapper.current.clientWidth + _this.scrollWrapper.current.scrollLeft + 1);
      }
    };
    _this.handleOnScroll = function (e, onScroll) {
      _this.updateNavControlStates();
      if (typeof onScroll === 'function') {
        onScroll(e);
      }
    };
    _this.getSlideWidth = function () {
      var slideWidth = _this.props.slideWidth;
      if (slideWidth > 0) {
        return slideWidth;
      }

      // If no `slideWidth` value, try using the width of the first slide.
      var firstSlideEl = _this.firstSlide.current;
      if (firstSlideEl) {
        return firstSlideEl.getBoundingClientRect().width;
      }
      return 0;
    };
    _this.nextPage = function () {
      /**
       * Reducing the scroll amount by half the width of a slide fixes
       * the problem when a slide is mostly visible on one page but
       * then gets completely skipped when you navigate to the next page.
       */
      var onNextClick = _this.props.onNextClick;
      var scrollEl = _this.scrollWrapper.current;
      var rect = scrollEl.getBoundingClientRect();
      var halfSlideWidth = _this.getSlideWidth() * 0.5;
      _this.scrollBy(rect.width - halfSlideWidth);
      onNextClick();
    };
    _this.previousPage = function () {
      var onPreviousClick = _this.props.onPreviousClick;
      var scrollEl = _this.scrollWrapper.current;
      var rect = scrollEl.getBoundingClientRect();
      var halfSlideWidth = _this.getSlideWidth() * 0.5;
      _this.scrollBy(-rect.width + halfSlideWidth);
      onPreviousClick();
    };
    _this.scrollToFocusedElement = function (evt) {
      /**
       * When tabbing, this tries to ensure the focused element is always visible.
       * If focused element is outside of the Carousel container, scroll by at least
       * one slide width.
       */
      if (evt.keyCode === _constants.KEY_CODES.TAB) {
        var focusElement = document.activeElement;
        var scrollEl = _this.scrollWrapper.current;
        var focusPosition = focusElement.getBoundingClientRect();
        var parentPosition = scrollEl.getBoundingClientRect();
        if (focusPosition && parentPosition) {
          if (focusPosition.right > parentPosition.right) {
            var overscrollAmount = focusPosition.right - parentPosition.right;
            var slideWidth = _this.getSlideWidth();
            var scrollAmount = overscrollAmount <= slideWidth ? slideWidth : overscrollAmount + slideWidth;
            _this.scrollBy(scrollAmount);
          }
          if (focusPosition.left < parentPosition.left) {
            var _overscrollAmount = parentPosition.left - focusPosition.left;
            var _slideWidth = _this.getSlideWidth();
            var _scrollAmount = _overscrollAmount <= _slideWidth ? _slideWidth : _overscrollAmount + _slideWidth;
            _this.scrollBy(-_scrollAmount);
          }
        }
      }
    };
    _this.firstSlide = /*#__PURE__*/(0, _react.createRef)();
    _this.scrollWrapper = /*#__PURE__*/(0, _react.createRef)();
    _this.sectionStart = /*#__PURE__*/(0, _react.createRef)();
    _this.sectionEnd = /*#__PURE__*/(0, _react.createRef)();
    _this.state = {
      previousEnabled: false,
      nextEnabled: false
    };
    _this.handleOnScroll = _this.handleOnScroll.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  var _proto = Carousel.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var scrollLeft = this.props.scrollLeft;
    if (this.scrollWrapper.current) {
      if (scrollLeft > 0) {
        this.scrollWrapper.current.scrollLeft = scrollLeft;
      }
    }
    window.addEventListener('resize', this.updateNavControlStates);
    this.updateNavControlStates();
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var scrollLeft = this.props.scrollLeft;
    var scrollEl = this.scrollWrapper.current;
    if (nextProps.scrollLeft !== scrollLeft) {
      var scrollDiff = nextProps.scrollLeft - scrollEl.getBoundingClientRect().left;
      this.scrollBy(scrollDiff);
    }
    return true;
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      // We don't need to call this when we have a state change, only when we're
      // given new props
      this.updateNavControlStates();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.updateNavControlStates);
  };
  _proto.scrollBy = function scrollBy(pixels) {
    var scrollEl = this.scrollWrapper.current;
    scrollEl.scrollLeft += pixels;
  };
  _proto.enableNextAction = function enableNextAction(atEnd) {
    var nextEnabled = this.state.nextEnabled;
    if (atEnd) {
      if (nextEnabled) {
        this.setState({
          nextEnabled: false
        });
      }
    } else if (!nextEnabled) {
      this.setState({
        nextEnabled: true
      });
    }
  };
  _proto.enablePreviousAction = function enablePreviousAction(atStart) {
    var previousEnabled = this.state.previousEnabled;
    if (atStart) {
      if (previousEnabled) {
        this.setState({
          previousEnabled: false
        });
      }
    } else if (!previousEnabled) {
      this.setState({
        previousEnabled: true
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      ariaLabel = _this$props['aria-label'],
      children = _this$props.children,
      enableSnap = _this$props.enableSnap,
      heading = _this$props.heading,
      includeSkipLink = _this$props.includeSkipLink,
      onNextClick = _this$props.onNextClick,
      onPreviousClick = _this$props.onPreviousClick,
      _onScroll = _this$props.onScroll,
      renderNavigationControls = _this$props.renderNavigationControls,
      role = _this$props.role,
      scrollOffset = _this$props.scrollOffset,
      slideAlign = _this$props.slideAlign,
      slideGap = _this$props.slideGap,
      slideWidth = _this$props.slideWidth,
      hasFocusableContent = _this$props.hasFocusableContent,
      rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    var cells = _react.Children.map(children, function (child, index) {
      return /*#__PURE__*/_react.default.createElement(_CarouselSlide.CarouselSlide, {
        ref: index === 0 ? _this2.firstSlide : undefined,
        slideAlign: slideAlign,
        slideWidth: slideWidth
      }, child);
    });
    var _this$state = this.state,
      previousEnabled = _this$state.previousEnabled,
      nextEnabled = _this$state.nextEnabled;
    return /*#__PURE__*/_react.default.createElement(_Carousel.StyledCarousel, (0, _extends2.default)({
      role: role,
      "aria-label": ariaLabel
    }, rest), /*#__PURE__*/_react.default.createElement(_CarouselHeader.CarouselHeader, null, /*#__PURE__*/_react.default.createElement(_CarouselHeadingArea.CarouselHeadingArea, null, heading && heading), renderNavigationControls && renderNavigationControls({
      onClick: this.previousPage,
      disabled: !previousEnabled
    }, {
      onClick: this.nextPage,
      disabled: !nextEnabled
    })), includeSkipLink ? /*#__PURE__*/_react.default.createElement(_CarouselSkipLink.CarouselSkipLink, {
      onClick: function onClick(e) {
        _this2.sectionEnd.current.focus();
        e.preventDefault();
      },
      ref: this.sectionStart
    }, "Skip to the end of the carousel") : null, /*#__PURE__*/_react.default.createElement(_CarouselScrollContainer.CarouselScrollContainer, {
      enableSnap: enableSnap,
      hasFocusableContent: hasFocusableContent,
      onKeyUp: this.scrollToFocusedElement,
      onScroll: function onScroll(e) {
        return _this2.handleOnScroll(e, _onScroll);
      },
      scrollOffset: scrollOffset,
      slideGap: slideGap,
      ref: this.scrollWrapper
    }, cells), includeSkipLink ? /*#__PURE__*/_react.default.createElement(_CarouselSkipLink.CarouselSkipLink, {
      onClick: function onClick(e) {
        _this2.sectionStart.current.focus();
        e.preventDefault();
      },
      ref: this.sectionEnd
    }, "Skip to the beginning of the carousel") : null);
  };
  return Carousel;
}(_react.Component);
exports.Carousel = Carousel;
Carousel.displayName = 'Carousel';
Carousel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * When true, the carousel will "snap" to the nearest slide after the user
   * clicks a nav control or finishes scrolling or swiping.
   *
   * By default, snap is enabled on desktop but disabled on mobile to protect
   * touch users from clunky, unexpected behavior. If needed, this can be changed
   * using an inline media query object.
   *
   * See the `slideAlign` and `scrollOffset` props for more controls.
   */
  enableSnap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * When false, the Carousel's content area will be focusable so that
   * users can control the container's scroll position with their keyboard
   */
  hasFocusableContent: _propTypes.default.bool,
  /**
   * A heading to display above the Carousel. Accepts a node (ex: `Heading`)
   * or a fragment with multiple nodes (ex: `Heading` + `Paragraph`).
   *
   * Try to provide heading copy that's descriptive enough so that a screen reader user
   * can decide whether they would want to view it or skip over it.
   */
  heading: _propTypes.default.node,
  /**
   * Callback function that's called when you click on the nav button that shows
   * the next set of slides.
   */
  onNextClick: _propTypes.default.func,
  /**
   * Callback function that's called when you click on the nav button that shows
   * the previous set of slides.
   */
  onPreviousClick: _propTypes.default.func,
  /**
   * An event handler that will be called with the carousel has been scrolled either via mouse,
   * swipe or the navigation buttons.
   */
  onScroll: _propTypes.default.func,
  /**
   * An array of slide content. Each piece of content will be wrapped in a `Carousel.Slide`
   * parent.
   */
  children: _propTypes.default.node,
  /**
   * Use to scroll the carousel to a specified position. Takes a number representing the number
   * of pixels to scroll from the beginning of the carousel.
   *
   * This prop may not work as expected when `enableSnap` is true.
   *
   * This feature comes via Trulia's ContentSlider. However it is not one of the requirements
   * so ignoring for now. We might replace it with the ability to autoscroll to a specific slide
   * index. However, any type of autoscrolling could cause confusion for keyboard users since
   * tabbing into the carousel starts them at the very first slide.
   *
   * Currently, we're primarily using this prop for unit testing.
   *
   * @ignore
   */
  scrollLeft: _propTypes.default.number,
  /**
   * When true, keyboard users will see a "skip" link they can use to skip past all of
   * the carousel content.
   *
   * "Skip" links appear at the beginning and end of a carousel.
   *
   * Note that MacOS/Firefox users can only tab to links if they enable it in their
   * System Preferences.
   */
  includeSkipLink: _propTypes.default.bool,
  /**
   * A render prop that returns the navigation controls. It takes two arguments: props
   * objects for the left and right buttons.
   */
  renderNavigationControls: _propTypes.default.func,
  /**
   * Sets padding for the left and right sides of the slide container. Useful for preventing
   * box shadows from getting cropped.
   *
   * Takes a spacing t-shirt size or number multiplier. Defaults to '0'.
   *
   * Supports inline media query objects.
   */
  scrollOffset: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  /**
   * When `enableSnap` is true, `slideAlign` determines how a slide should try to
   * align within its container. Applied using
   * [`scroll-snap-align`](https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-snap-align).
   */
  slideAlign: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['start', 'end', 'center'])),
  /**
   * Sets the gutter size between slides.
   *
   * Takes a spacing t-shirt size or number multiplier. Defaults to 'xs'.
   *
   * Supports inline media query objects.
   */
  slideGap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  /**
   * Sets the width of a slide using `flex-basis`. Takes a number or the,
   * default, `auto`.
   *
   * Supports inline media query objects.
   */
  slideWidth: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]))
} : {};
Carousel.defaultProps = {
  children: null,
  enableSnap: {
    default: false,
    lg_gte: true
  },
  hasFocusableContent: true,
  onNextClick: function onNextClick() {},
  onPreviousClick: function onPreviousClick() {},
  scrollLeft: 0,
  scrollOffset: 0,
  slideAlign: 'start',
  slideGap: 'sm',
  slideWidth: 'auto',
  includeSkipLink: true,
  renderNavigationControls: function renderNavigationControls(leftButtonProps, rightButtonProps) {
    return /*#__PURE__*/_react.default.createElement(_CarouselNavControls.CarouselNavControls, {
      leftButtonProps: leftButtonProps,
      rightButtonProps: rightButtonProps
    });
  }
};
Carousel.Header = _CarouselHeader.CarouselHeader;
Carousel.HeadingArea = _CarouselHeadingArea.CarouselHeadingArea;
Carousel.NavControls = _CarouselNavControls.CarouselNavControls;
Carousel.ScrollContainer = _CarouselScrollContainer.CarouselScrollContainer;
Carousel.SkipLink = _CarouselSkipLink.CarouselSkipLink;
Carousel.Slide = _CarouselSlide.CarouselSlide;